<template>
  <mdb-row>
    <mdb-col>
      <mdb-autocomplete
        v-model="selectedName"
        :data="surrogatenamelist"
        :label="$t('surrogate_name')"
        :placeholder="$t('surrogate_name')"
        @input="getSelectValue"
        @search="getSelectValue"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbCol, mdbRow, mdbAutocomplete } from "mdbvue";

export default {
  name: "UnionMemberSelection",
  components: {
    mdbCol,
    mdbRow,
    mdbAutocomplete
  },
  props: {
    defaultSelection: String,
  },
  data: () => ({
    loadReady: false,
    selectedName: "",
    surrogatenamelist: [],
    surrogatenames: [],
    surrogatenamepath: "/1.0/front/surrogateimport/names",
  }),
  methods: {
    createSelect() {
      this.surrogatenamelist = this.surrogatenames.map(s => s.name);
    },
    getSelectValue(val) {
      this.$emit("surrogatename", val);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      if (newVal !== null) {
        this.createSelect();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.$http
      .get(this.surrogatenamepath)
      .then((response) => {
        if (response.status == 200) {
          this.surrogatenames = response.data.surrogateimportnames;
          this.createSelect();
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        window.__logAxiosErrorIfDebug(error, {
          context: "SurrogateNameSelection.vue - mounted",
        });
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>

<style>
</style>
